module.exports = __webpack_public_path__ + "static/img/preloader.9509900b.gif";